import React, { useState } from 'react';
import logo from '../assets/logo-suncast.png';

const NEXOR_URL = 'https://nexor.suncast.cl';
const ORANGE = '#ff9900';
const KAM_EMAIL = 'scastillo@suncast.cl';
const KAM_NAME = 'Stefany Castillo';

export const NexorAvailable = () => {
    const [copied, setCopied] = useState(false);

    const handleRedirectToNexor = () => {
        window.location.href = NEXOR_URL;
    };

    const handleCopyEmail = async () => {
        try {
            await navigator.clipboard.writeText(KAM_EMAIL);
        } catch (err) {
            // Fallback para navegadores/contextos sin Clipboard API
            const textarea = document.createElement('textarea');
            textarea.value = KAM_EMAIL;
            textarea.style.position = 'fixed';
            textarea.style.opacity = '0';
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
        }
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    // La plataforma fue dada de baja: el modal se muestra siempre, no puede
    // cerrarse y solo permite avanzar a Nexor mediante el botón. Mientras
    // tanto, la aplicación permanece bloqueada.
    return (
        <div style={styles.overlay}>
            <style>{keyframes}</style>

            <div style={styles.card}>
                <img src={logo} alt="Suncast" style={styles.logo} />

                <h1 style={styles.title}>¡Nexor ya está disponible!</h1>

                <p style={styles.paragraph}>
                    Todas las funcionalidades que utilizaba aquí ahora están
                    disponibles en{' '}
                    <a href={NEXOR_URL} style={styles.link}>Nexor</a>, la nueva
                    plataforma de Suncast. Le recomendamos actualizar sus accesos o
                    marcadores para ingresar desde ahora en adelante.
                </p>

                <div style={styles.helpBox}>
                    <p style={styles.helpTitle}>¿Todavía no tiene acceso a Nexor?</p>
                    <p style={styles.helpText}>
                        Le recomendamos contactar a {KAM_NAME}, KAM de Suncast, para
                        revisar su caso y gestionar la habilitación de su usuario.
                    </p>
                    <button
                        type="button"
                        onClick={handleCopyEmail}
                        style={styles.mailButton}
                        title="Copiar correo"
                        onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#fff0d6'; }}
                        onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#ffffff'; }}
                    >
                        {copied ? (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
                                <path d="M5 12l5 5L20 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        ) : (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" style={{ flexShrink: 0 }}>
                                <rect x="9" y="9" width="11" height="11" rx="2" stroke="currentColor" strokeWidth="1.8" />
                                <path d="M5 15V5a2 2 0 012-2h10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                            </svg>
                        )}
                        {copied ? '¡Correo copiado!' : KAM_EMAIL}
                    </button>
                </div>

                <button
                    type="button"
                    onClick={handleRedirectToNexor}
                    style={styles.button}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#e68a00'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = ORANGE; }}
                >
                    Ir a Nexor
                </button>
            </div>
        </div>
    );
};

const keyframes = `
@keyframes nexor-fade-in {
    from { opacity: 0; transform: translateY(14px); }
    to { opacity: 1; transform: translateY(0); }
}
`;

const styles = {
    overlay: {
        position: 'fixed',
        inset: 0,
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '16px',
        background: '#f2f2f3',
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        maxWidth: '440px',
        background: '#ffffff',
        borderRadius: '16px',
        padding: '40px 36px 32px',
        textAlign: 'center',
        borderTop: `4px solid ${ORANGE}`,
        boxShadow: '0 12px 40px rgba(0, 0, 0, 0.12)',
        animation: 'nexor-fade-in 0.4s ease-out',
    },
    logo: {
        display: 'block',
        height: '52px',
        objectFit: 'contain',
        marginBottom: '28px',
    },
    title: {
        fontSize: '25px',
        fontWeight: 700,
        color: '#2b2b30',
        margin: '0 0 16px',
    },
    paragraph: {
        fontSize: '15px',
        lineHeight: 1.6,
        color: '#4a4a52',
        margin: '0 0 26px',
    },
    link: {
        color: '#4440c7',
        fontWeight: 700,
        textDecoration: 'none',
    },
    button: {
        width: '100%',
        marginTop: '22px',
        padding: '13px 20px',
        fontSize: '15px',
        fontWeight: 600,
        color: '#ffffff',
        background: ORANGE,
        border: 'none',
        borderRadius: '10px',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
    },
    helpBox: {
        width: '100%',
        boxSizing: 'border-box',
        padding: '18px 18px 16px',
        background: '#fff7ec',
        border: '1px solid #ffe3b8',
        borderRadius: '12px',
        textAlign: 'center',
    },
    helpTitle: {
        fontSize: '14px',
        fontWeight: 600,
        color: '#2b2b30',
        margin: '0 0 4px',
    },
    helpText: {
        fontSize: '13px',
        lineHeight: 1.55,
        color: '#6a6a72',
        margin: '0 0 12px',
    },
    mailButton: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        minWidth: '210px',
        padding: '9px 16px',
        fontSize: '13.5px',
        fontWeight: 600,
        color: '#b56b00',
        background: '#ffffff',
        border: '1px solid #ffcf85',
        borderRadius: '9px',
        cursor: 'pointer',
        transition: 'background-color 0.2s ease',
    },
};
